/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon20Light = forwardRef('ArrowDRadiusDownLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17 4.5a6.5 6.5 0 0 1-6.5 6.5H3.207l4.647-4.646a.5.5 0 1 0-.708-.708l-4.651 4.652a1.7 1.7 0 0 0 0 2.404l4.651 4.652a.5.5 0 0 0 .708-.708L3.207 12H10.5A7.5 7.5 0 0 0 18 4.5v-1a.5.5 0 1 0-1 0v1Z" })));
});
